import { DialogContent } from '@mui/material';
import DashboardCards from '@widgets/dashboard/DashboardCards';

export default function ActiveCardsDialog() {
  return (
    <DialogContent>
      <DashboardCards />
    </DialogContent>
  );
}
